import { action } from 'typesafe-actions';
import {
  IFiltroSaida,
  Pagination,
  IItensNota,
  SolicitacoesRetornoTypes,
  ISolicitacoesRetorno,
  IFilter,
} from './types';

export const loadRequest = (
  filtro: IFiltroSaida | any,
  inscricaoAtiva: any,
  cddAtivo: number | undefined,
  pagination?: Pagination,
  sorter?: any
) =>
  action(SolicitacoesRetornoTypes.LOAD_REQUEST, {
    filtro,
    inscricaoAtiva,
    cddAtivo,
    pagination,
    sorter,
  });
export const loadSuccess = (data: ISolicitacoesRetorno[], pagination: Pagination) =>
  action(SolicitacoesRetornoTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(SolicitacoesRetornoTypes.LOAD_FAILURE);

export const cleanDetalhesNota = () => action(SolicitacoesRetornoTypes.CLEAN_DETALHES_ITENS_NOTA);

export const itensNotaSecundariasRequest = (
  nuNota: number | undefined,
  centroDistribuicao: number | undefined
) =>
  action(SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_REQUEST, { nuNota, centroDistribuicao });
export const itensNotaSecundariasSuccess = (notas: IItensNota[]) =>
  action(SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_SUCCESS, { notas });
export const itensNotaSecundariasFailure = () =>
  action(SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_FAILURE);

export const filterSolicitacoesRetorno = (filter: IFilter) =>
  action(SolicitacoesRetornoTypes.FILTER_SOLICITACOES_RETORNO, { filter });

export const sorterSolicitacoesRetorno = (ordenacao: any) =>
  action(SolicitacoesRetornoTypes.SORTER_SOLICITACOES_RETORNO, { ordenacao });

export const cleanDetalhesNotaSecundarias = () =>
  action(SolicitacoesRetornoTypes.CLEAN_DETALHES_ITENS_NOTA_SECUNDARIAS);

export const cleanStateMoviSaida = () => action(SolicitacoesRetornoTypes.CLEAN_MOVISAIDA);
